import { takeLatest } from 'redux-saga/effects'
import { AUTH_SAGA } from 'src/store/types/auth'
import fetchAuth from './fetchAuth'

export function* authDataSaga() {
  yield takeLatest(AUTH_SAGA, fetchAuth)
}
